import * as React from 'react';

const ToastTickIcon = ({fillColor = '#11D200'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={12} fill="none">
    <path
      fill={fillColor}
      d="M5.45 9.7 14.525.625A.738.738 0 0 1 15.064.4a.73.73 0 0 1 .536.227c.15.15.225.33.225.537a.732.732 0 0 1-.225.536l-9.625 9.625a.72.72 0 0 1-.525.225.72.72 0 0 1-.525-.225l-4.55-4.55a.696.696 0 0 1-.212-.538.777.777 0 0 1 .239-.537c.15-.15.33-.225.537-.225.208 0 .386.075.536.225l3.975 4Z"
    />
  </svg>
);

export default ToastTickIcon;
